// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1bkd0","clinicsSelect":"styles_clinicsSelect__2O8Zk"};